import { styled } from "styled-components";

export const ContentContainer = styled.div`
    display: flex;
    margin-top: 15px;
`

export const Input = styled.input`
    padding: 10px;
    font-size: 16px;
    border: 2px solid #ccc;
    border-radius: 5px;
    outline: none;
    transition: border-color 0.3s;
    max-width: 100px;
    &:focus {
        border-color: #007bff;
    }
`;

export const Label = styled.label`
    text-align: right;
    font-weight: bold;
    padding-right: 10px;
    max-width: 300px;
    width: 100%;
`

export const RowForm = styled.div`
    display: flex;
    padding-top: 10px;
`

export const InputContainer = styled.div`
    display: block;
    align-items: center;
    max-width: 400px; 
    margin-left: 10px;
`

export const ChartContainer = styled.div`
    position: relative;
    width: 100%;
    margin: auto;
    max-width: 1200px;
`

export const ModelSIS = styled.div`
    max-height: ${({ display_options }) => (display_options === 'true' ? '800px' : '0')};
    overflow: hidden;
    transition: max-height 0.5s ease;
`

export const ModelSIR = styled.div`
    max-height: ${({ display_options }) => (display_options === 'true' ? '800px' : '0')};
    overflow: hidden;
    transition: max-height 0.5s ease;
`

export const ModelSEIRD = styled.div`
    max-height: ${({ display_options }) => (display_options === 'true' ? '800px' : '0')};
    overflow: hidden;
    transition: max-height 0.5s ease;
`

export const Modelchoice = styled.div`
    display: inline-block;
    margin: 5px;
    margin-left: 25px;
    max-width: 400px;
`

export const InputRadioButton = styled.input`
    
`
export const ModelText = styled.div`
    border-top-style: solid;
    border-bottom-style: solid;
    padding-top: 10px;
    padding-bottom: 10px;
    border-color: #8d8d8d;
    font-weight: bold;
    text-align: center;
    margin-top: 15px;
    margin-bottom: 15px;
    width: 100%;
`